
import React, { useState } from 'react';
import { addAndRemoveDisabledCls, isValidEmail } from '../../utils/utils';
import { submitInventivContactForm } from '../../utils/campaign';

const Footer = () => {
  const [fEmail, setFEmail] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  //
  const submit = async (e) => {
    e.preventDefault();

    if (fEmail && isValidEmail(fEmail)) {
        // call api
        const data = {
            email: fEmail,
            name: fEmail,
            phone: '',
            subject: '[Inventiv] New subscribe from ' + fEmail,
            message: `New subscribe from  ${fEmail}`,
            site: 'inventiv.org'
        }

        // submit activecampaign
        submitInventivContactForm(data);
        
        // add to our database
        fetch("https://api.trustyip.com/subcribers/add", {
        "method": "POST",
        "headers": {
            "content-type": "application/json",
            "accept": "application/json"
        },
        "body": JSON.stringify(data)
        })
        .then(response => response.json())
        .then(response => {
            alert('Thank you for contacting us. We will follow up with you soon');
            // reset
            setFEmail('');
            setEmailSent(true);
        })
        .catch(err => {
            alert('There is something wrong. Please try again later!');
            console.log(err);
        });
        //
        addAndRemoveDisabledCls('subscribeBtn');
    } else {
        alert('Please enter your valid email.');
    }

  }

  return (
    <>
      {/* <!-- Subscribe --> */}
      <div class="container">
        <div class="row">
          <div class="co-12 col-md-6 offset-md-3 mt-3">
            <div class="theme-card footerNewsletter wow fadeInUp delay-04s"
              style={{visibility: 'visible', animationName: 'fadeInUp' }}>
              <p>
                <strong>Subscribe to our Newsletter</strong>
              </p>

              <form action="">
                <div class="row">
                  <div class="col-12 col-md-8 ">
                    <div class="input-group">
                      <span class="input-group-addon"><i class="fa fa-envelope d-clr"></i></span>
                      <input type="text" class="form-control" placeholder="Your Email" required="" value={fEmail} onChange={e => setFEmail(e.target.value)}/>
                    </div>
                  </div>
                  <div class="btn-box col-12 col-md-3">
                    <input type="button" class="btn btn-default" id="subscribeBtn" value="Subscribe" onClick={submit}/>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Thank you start --> */}
      <div class="thank-you wow fadeInDown delay-04s">
        <div class="container">
          <div class="row">
            <div class="col-12 text-center">
              <h2 class="w-clr text-left h5">
                Inventiv Foundation, Inc.
                PO Box 1065 Zephyr Cove,
                NV 89448
              </h2>
              <h3 class="w-clr text-left h6">
                Tax ID Number: 83-0668793
              </h3>
              <div class="text-center social">
                <ul>
                  <li>
                    <a class="" href="#" aria-label='Facebook'>
                      <i class="fa fa-facebook w-clr"></i>
                    </a>
                  </li>
                  <li>
                    <a class="" href="#" aria-label='Twitter'>
                      <i class="fa fa-twitter w-clr"></i>
                    </a>
                  </li>
                  <li>
                    <a class="" href="#" aria-label='Linkedin'>
                      <i class="fa fa-linkedin w-clr"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            {/* <div class="col-12 col-md-3">
              <ul>
                <li class="text-left">
                  <a href="/#who-we-are" class="w-clr">About Us</a>
                </li>
                <li class="text-left">
                  <a href="/blog" class="w-clr">News</a>
                </li>
                <li class="text-left">
                  <a href="/contact" class="w-clr">Contact</a>
                </li>
                <li class="text-left">
                  <a href="/inventor-resources" class="w-clr">Inventor Resources</a>
                </li>
              </ul>
            </div>
            <div class="col-12 col-md-3">
              <ul>
                <li class="text-left">
                  <a href="#" class="w-clr">Terms of Use</a>
                </li>
                <li class="text-left">
                  <a href="#" class="w-clr">Privacy Policy</a>
                </li>

              </ul>
            </div>
            <div class="col-12 col-md-3 social">
              <ul>
                <li>
                  <a class="" href="#" aria-label='Facebook'>
                    <i class="fa fa-facebook w-clr"></i>
                  </a>
                </li>
                <li>
                  <a class="" href="#" aria-label='Twitter'>
                    <i class="fa fa-twitter w-clr"></i>
                  </a>
                </li>
                <li>
                  <a class="" href="#" aria-label='Linkedin'>
                    <i class="fa fa-linkedin w-clr"></i>
                  </a>
                </li>
              </ul>
            </div> */}
          </div>
        </div>
      </div>
      {/* <!-- Thank you end --> */}
      {/* <a id="page_scroller" href="#top" style={{position: 'fixed', 'zIndex': 2147483647, display: 'none' }}><i
        class="fa fa-chevron-up"></i></a> */}

      {/* <!-- Full Page Search --> */}
      <div id="full-page-search">
        <button type="button" class="close">×</button>
        <form action="#">
          <input type="search" value="" placeholder="type keyword(s) here" />
          <button type="button" class="btn btn-sm btn-color">Search</button>
        </form>
      </div>
    </>
  )
}

export default Footer
